module.exports = __webpack_public_path__ + "img/green_circle.5917a175.svg";